import { request } from '@/shared/api/request'

export const createEditProfile = (payload) => {
	return request({ url: '/user/save/personDetails', method: 'POST', data: payload })
}
